import React, {Component} from 'react';
import {observer} from "mobx-react";
import {reaction} from "mobx";
import {checkbox, custom, input} from "../../../utils/linker";
import axios from "../../../utils/axios";
import HTML from "../../Helpers/HTML";

class Embed extends Component {
  constructor(props) {
    super(props);
    this._reactionUnmount=reaction(()=>{
      return this.props.linker.value.url;
    },(val)=>{
      this.getOembed(val);
    });
  }
  componentWillUnmount() {
    this._reactionUnmount();
  }

  getOembed(url)
  {
    if(url) {
      axios.post(`/sysapi/getOembed`, {url: url}).then((data) => {
        if (data.data.answer) {
          const scriptId = `script_${data.data.answer.provider_name}`;
          if (data.data.answer.add_js) {
            if (!document.getElementById(scriptId)) {
              const s = document.createElement('script');
              s.type = 'text/javascript';
              s.async = true;
              s.src = data.data.answer.add_js;
              s.id = scriptId;
              document.getElementsByTagName("head")[0].appendChild(s);
            } else {
              if (typeof window.twttr !== "undefined") {
                window.twttr.widgets.load();
              }
            }
          }
        }
        console.log('this.props.linker.value', this.props.linker.value);
        if (this.props.linker.value) {
          this.props.linker.value.oembed = data.data.answer;
        }
      });
    }
  }
  renderVideoWrapper(inner) {
    return (
      <div style={{ maxWidth:400 }}>
        <div style={{paddingBottom: '66%'}}
             className={`oembedHere pr content_type_${this.props.linker.value.oembed.type} provider_${this.props.linker.value.oembed.provider_name}`}>
          <div className="pa pa-tl w100 h100">
            <div className="pr w100 h100">
              {inner}
            </div>
          </div>
        </div>
      </div>
    )
  }
  renderOembed() {
    if(this.props.linker.value.oembed) {
      if(this.props.linker.value.oembed.type == "video") {
        return this.renderVideoWrapper(
          <HTML>{this.props.linker.value.oembed.html}</HTML>
        );
      }
      return (
        <HTML>{this.props.linker.value.oembed.html}</HTML>
      )
    }
  }
  render() {
    return (
      <div className="padd20 bg-w2 pr rad4 mbottom10">
        <div className="pa pa-tr mdi mdi-close sc1 fs24 lh10 pointer" onClick={()=>{ this.props.deleteMe(); }}></div>
        {this.renderOembed()}
        <input  autoFocus={true} {...input(this.props.linker.value,"url")} type="text" className="w100 big" />
        <div className="ptop5 sc1 fs13">
          Ввыдете ссылку на встраиваемый объект. Поддерживаются следующие сервисы: youtube, vimeo, twitter, soundcloud.
        </div>
        <div className="ptop5">
          <label>
            <input type="checkbox" value="1" {...checkbox(this.props.linker.value,"spoiler")} /><span className="vam"></span> <span className="dib vam">Есть спойлеры</span>
          </label>
        </div>
      </div>
    )
  }
}

export default observer(Embed);